import React from 'react';
import './DateNavigation.css';

const DateNavigation = ({ currentDate, onDateChange }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const isToday = currentDate.getTime() === today.getTime();
  const isYesterday = currentDate.getTime() === today.getTime() - 24 * 60 * 60 * 1000;
  const isTomorrow = currentDate.getTime() === today.getTime() + 24 * 60 * 60 * 1000;

  const formatDate = (date) => {
    const options = { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric' 
    };
    return date.toLocaleDateString('en-US', options);
  };

  const getDateLabel = () => {
    if (isToday) return 'Today';
    if (isYesterday) return 'Yesterday';
    if (isTomorrow) return 'Tomorrow';
    return formatDate(currentDate);
  };

  const goToPreviousDay = () => {
    const previousDay = new Date(currentDate);
    previousDay.setDate(previousDay.getDate() - 1);
    onDateChange(previousDay);
  };

  const goToNextDay = () => {
    const nextDay = new Date(currentDate);
    nextDay.setDate(nextDay.getDate() + 1);
    onDateChange(nextDay);
  };

  const goToToday = () => {
    onDateChange(today);
  };

  // Don't allow navigation too far into the future
  const maxFutureDate = new Date(today);
  maxFutureDate.setDate(maxFutureDate.getDate() + 7);
  const canGoForward = currentDate < maxFutureDate;

  // Don't allow navigation too far into the past
  const minPastDate = new Date(today);
  minPastDate.setDate(minPastDate.getDate() - 30);
  const canGoBack = currentDate > minPastDate;

  return (
    <div className="date-navigation">
      <button 
        className="nav-button prev" 
        onClick={goToPreviousDay}
        disabled={!canGoBack}
        aria-label="Previous day"
      >
        ←
      </button>
      
      <div className="date-display">
        <h2 className="date-label">{getDateLabel()}</h2>
        <p className="date-full">{formatDate(currentDate)}</p>
        {!isToday && (
          <button className="today-button" onClick={goToToday}>
            Go to Today
          </button>
        )}
      </div>
      
      <button 
        className="nav-button next" 
        onClick={goToNextDay}
        disabled={!canGoForward}
        aria-label="Next day"
      >
        →
      </button>
    </div>
  );
};

export default DateNavigation;
